/**
 * This file is generated from scripts/genIconComponents.ts. Any
 * changes should be made in that file.
 */
import { color as colorFn } from "@smartsheet/design-tokens-react";
import React, { CSSProperties, forwardRef, Ref } from "react";
import { GeneratedIconProps } from "../../components/icon/GeneratedIconProps";
import { Icon } from "../../components/icon/Icon";
import { getUrsaIconColorVarName } from "../../components/icon/getUrsaIconColorVarName";
import CloseIcon16 from "./CloseIcon16";
import CloseIcon20 from "./CloseIcon20";
import CloseIcon24 from "./CloseIcon24";

const getSizeMap = (viewBox?: string, width?: string | number, height?: string | number) => {
    return {
        16: viewBox ? (
            <CloseIcon16 viewBox={viewBox} width={width ? width : 16} height={height ? height : 16} />
        ) : (
            <CloseIcon16 width={width ? width : 16} height={height ? height : 16} />
        ),
        20: viewBox ? (
            <CloseIcon20 viewBox={viewBox} width={width ? width : 20} height={height ? height : 20} />
        ) : (
            <CloseIcon20 width={width ? width : 20} height={height ? height : 20} />
        ),
        24: viewBox ? (
            <CloseIcon24 viewBox={viewBox} width={width ? width : 24} height={height ? height : 24} />
        ) : (
            <CloseIcon24 width={width ? width : 24} height={height ? height : 24} />
        ),
    };
};

export interface CloseIconProps extends GeneratedIconProps {
    /**
     * The size to render the icon at.
     */
    size: 16 | 20 | 24;
}

/**
 * Close or dismiss an element/panel/modal/banner that is open
 */

export const CloseIcon = forwardRef(
    (
        {
            // This is the default icon color.
            color = `var(${getUrsaIconColorVarName()}, ${colorFn("color--icons--neutral--strongest")})`,
            size,
            viewBox,
            width,
            height,
            style,

            ...rest
        }: CloseIconProps,
        ref: Ref<HTMLElement>
    ) => {
        return (
            <Icon
                color={color}
                ref={ref}
                size={size}
                width={width}
                height={height}
                {...rest}
                style={
                    {
                        ...style,
                    } as CSSProperties
                }
            >
                {getSizeMap(viewBox, width, height)[size]}
            </Icon>
        );
    }
);
CloseIcon.displayName = "CloseIcon";
